import { Car } from '../entities/Car';
import type { CarStats, CarTuning } from './CarTypes';

export function createCarFromStats(stats: CarStats, tuning?: CarTuning): Car {
  return new Car({ ...stats }, tuning);
}
